var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{class:{'pointer': _vm.notification.to},attrs:{"type":_vm.notification.type,"dismissible":""},on:{"click":_vm.navigate}},[_vm._v(" "+_vm._s(_vm.notification.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }